// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
// for support MessageProcessorBase.call(this,... in *.js function class
import { type PFixFieldSet } from '../Fields/PFixFieldSet';

export const MessageProcessorBase = function (): void {

};

MessageProcessorBase.prototype.decode = function (fieldset: PFixFieldSet) {
    throw new Error('Not implemented');
};

// for extend MessageProcessorBase in *.ts class
export class MessageProcessorBaseClass {
    decode = (fieldset: PFixFieldSet): any[] => {
        throw new Error('Not implemented');
    };
}
